<div #patternRoot class="ba-typeahead" [attr.id]="'typeahead-pattern-' + name">

    <label [attr.id]="'ta-label-' + name" [attr.for]="'ta-input-' + name">{{ label }}</label>
    <div class="dropdown">
        <span class="sr-only" [attr.id]="'ta-sr-' + name">{{ 'common.search-hint' | i18next }}</span>
        <input
                class="form-control"
                type="text"
                autocomplete="off"
                [id]="'ta-input-' + name"
                [name]="name + '-search'"
                [attr.aria-describedby]="'ta-sr-' + name + (extraInfos ? ' ta-extraInfos-' + name : '')"
                [attr.aria-controls]="'ta-ul-' + name"
                [attr.aria-labelledby]="'ta-label-' + name"
                aria-autocomplete="list"
                aria-haspopup="listbox"
        />

        <ul
                class="dropdown-menu ba-typeahead-results"
                [attr.id]="'ta-ul-' + name"
                [attr.aria-label]="'common.search-suggestions' | i18next"
        >
        </ul>
    </div>

    @if (extraInfos) {
        <p class="form-text" [attr.id]="'ta-extraInfos-' + name">
            {{ extraInfos }}
        </p>
    }
</div>